<form [formGroup]="form" (ngSubmit)="onSubmit()" class="card integration-settings-form">
  <div class="card-body">
    <div class="mb-3">
      <div class="d-flex align-items-center gap-2">
        <p-toggleswitch
          formControlName="enabled"
          inputId="answeringMachineDetectionEnabled"></p-toggleswitch>
        <label for="answeringMachineDetectionEnabled" class="form-label mb-0">
          {{ 'Settings::AnsweringMachineDetectionEnabled' | abpLocalization }}
        </label>
      </div>
      <small class="form-text text-muted">
        {{ 'Settings::AnsweringMachineDetectionEnabledDescription' | abpLocalization }}
      </small>
    </div>

    <div class="mb-3">
      <div class="d-flex align-items-center gap-2">
        <p-toggleswitch
          formControlName="agentOutboundEnabled"
          inputId="answeringMachineDetectionAgentOutboundEnabled"></p-toggleswitch>
        <label for="answeringMachineDetectionAgentOutboundEnabled" class="form-label mb-0">
          {{ 'Settings::AnsweringMachineDetectionAgentOutboundEnabled' | abpLocalization }}
        </label>
      </div>
      <small class="form-text text-muted">
        {{ 'Settings::AnsweringMachineDetectionAgentOutboundEnabledDescription' | abpLocalization }}
      </small>
    </div>

    <div class="mb-3">
      <label for="detectionTimeoutSeconds" class="form-label">
        {{ 'Settings::AnsweringMachineDetectionTimeoutSeconds' | abpLocalization }}
      </label>
      <input
        id="detectionTimeoutSeconds"
        type="number"
        class="form-control"
        formControlName="detectionTimeoutSeconds"
        [min]="minTimeoutSeconds"
        [max]="maxTimeoutSeconds"
        step="1"
        [class.is-invalid]="isControlInvalid('detectionTimeoutSeconds')" />
      @if (hasError('detectionTimeoutSeconds', 'required')) {
        <div class="invalid-feedback">
          {{ 'Settings::AnsweringMachineDetectionTimeoutSeconds' | abpLocalization }}
          {{ '::Required' | abpLocalization }}
        </div>
      }
      @if (hasError('detectionTimeoutSeconds', 'min') || hasError('detectionTimeoutSeconds', 'max')) {
        <div class="invalid-feedback">
          {{ 'Settings::AnsweringMachineDetectionTimeoutSecondsInvalid' | abpLocalization }}
        </div>
      }
      @if (!isControlInvalid('detectionTimeoutSeconds')) {
        <small class="form-text text-muted">
          {{ 'Settings::AnsweringMachineDetectionTimeoutSecondsDescription' | abpLocalization }}
        </small>
      }
    </div>
  </div>

  <div class="integration-settings-form__footer">
    <cx-form-actions
      layout="inline"
      [showCancel]="false"
      [saveLabel]="isSubmitting ? ('::Saving' | abpLocalization) : ('::Save' | abpLocalization)"
      [disabled]="isSubmitting"
      [isSubmitting]="isSubmitting">
    </cx-form-actions>
  </div>
</form>
